import React, { useMemo } from "react";
import { TransformedProduct } from "../../../types/productApiTypes";
import { resolveCardImages } from "../../../helpers/productApiHelpers/imageResolver";
import { ImageSourceType } from "../../../../../../types/globalTypes";

interface CardImageProps {
  product: TransformedProduct;
}

const CardImage: React.FC<CardImageProps> = ({ product }) => {
  const config = window.commonVariables?.uiSettings?.imageResolution
    ?.productCard || {
    primary: ["VARIATION_MAIN", "PARENT_MAIN"] as ImageSourceType[],
    hover: ["PARENT_GALLERY", "PARENT_MAIN"] as ImageSourceType[],
  };

  const { primaryImage: mainImage, hoverImage } = useMemo(
    () => resolveCardImages(product, config),
    [product, config],
  );

  return (
    <a href={product.permalink} aria-label={`View details for ${product.name}`}>
      {mainImage ? (
        <img
          src={mainImage.thumbnail}
          srcSet={mainImage.srcset}
          // The grid has roughly 4 columns on desktop, 2 on tablet, 1 on mobile
          sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
          alt={mainImage.alt || product.name}
          className="product-card__image product-card__image--primary"
          loading="lazy"
          decoding="async"
        />
      ) : (
        <div className="product-card__image-placeholder"></div>
      )}

      {hoverImage && (
        <img
          src={hoverImage.thumbnail}
          srcSet={hoverImage.srcset}
          sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
          alt={hoverImage.alt || product.name}
          className="product-card__image product-card__image--secondary"
          aria-hidden="true"
          loading="lazy"
          decoding="async"
        />
      )}
    </a>
  );
};

export default CardImage;
